import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=38e89bc6&scoped=true"
import script from "./Permisos.vue?vue&type=script&lang=js"
export * from "./Permisos.vue?vue&type=script&lang=js"
import style0 from "./Permisos.vue?vue&type=style&index=0&id=38e89bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e89bc6",
  null
  
)

export default component.exports